import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { styled } from '@linaria/react';

import { useOrgUser } from 'contexts/OrgUserContext.jsx';
import { COLORS, typographyStyles } from '@livecommerce/design-system';

export const { getBodyText, getLargeHeadline } = typographyStyles;

const bodyText14 = getBodyText(14);
const displayText92 = getLargeHeadline(92);

const Image = styled.img`
  border-radius: 6px;
  width: ${(props) => props.width}px;
  height: ${(props) => props.height}px;
`;

const NoImage = styled.div`
  border-radius: 6px;
  background-color: ${COLORS.blackLight};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${COLORS.white};
  width: ${(props) => props.width}px;
  height: ${(props) => props.height}px;
  font-weight: ${(props) => (props.width >= 214 ? displayText92.fontWeight : bodyText14.fontWeight)};
  font-size: ${(props) => (props.width >= 214 ? displayText92.fontSize : bodyText14.fontSize)};
  font-family: ${(props) => (props.width >= 214 ? displayText92.fontFamily : bodyText14.fontFamily)};
  line-height: ${(props) => (props.width >= 214 ? displayText92.lineHeight : bodyText14.lineHeight)};
`;

const getLetters = (displayName) => {
  const matches = displayName.match(/\b(\w)/g);
  if (!matches) return '';
  return matches.slice(0, 2).join('').toUpperCase();
};

const ProfileImage = ({ width = 32, height = 32, alt, ...props }) => {
  const {
    userData: { avatar, displayName },
  } = useOrgUser();
  const authUser = useSelector((state) => state.sessionState.authUser);
  const letters = getLetters(displayName || authUser?.displayName || authUser?.email || '');

  if (!avatar) {
    return (
      <NoImage width={width} height={height} {...props}>
        {letters}
      </NoImage>
    );
  }

  return <Image width={width} height={height} src={avatar} alt={alt} {...props} />;
};

ProfileImage.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  alt: PropTypes.string,
};

export default ProfileImage;
